__turbopack_context__.v({
  "content_container": "styles-module-scss-module__y8Ww9q__content_container",
  "cta": "styles-module-scss-module__y8Ww9q__cta",
  "cta_background": "styles-module-scss-module__y8Ww9q__cta_background",
  "cta_container": "styles-module-scss-module__y8Ww9q__cta_container",
  "cta_link": "styles-module-scss-module__y8Ww9q__cta_link",
  "cta_wrapper": "styles-module-scss-module__y8Ww9q__cta_wrapper",
  "stats_container": "styles-module-scss-module__y8Ww9q__stats_container",
  "theme_keyline": "styles-module-scss-module__y8Ww9q__theme_keyline",
});
